<script setup lang="ts">
import AppShell from '@/components/AppShell.vue';
</script>

<template>
  <AppShell />
</template>
